import { render, staticRenderFns } from "./TnAlarmRule.vue?vue&type=template&id=3500ed69"
import script from "./TnAlarmRule.vue?vue&type=script&lang=js"
export * from "./TnAlarmRule.vue?vue&type=script&lang=js"
import style0 from "./TnAlarmRule.vue?vue&type=style&index=0&id=3500ed69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports